module.exports = __webpack_public_path__ + "2-es2015.a04ec3d69def963d84d4.worker.js"